import { render, staticRenderFns } from "./DisplayText.vue?vue&type=template&id=16de9cca&scoped=true"
import script from "./DisplayText.vue?vue&type=script&lang=ts"
export * from "./DisplayText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de9cca",
  null
  
)

export default component.exports